import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button, Spinner } from 'react-bootstrap';
import { FaEnvelope, FaLock, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import axios from 'axios';

function AdminLoginModal({ show, handleClose }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [redirecting, setRedirecting] = useState(false);

    const validateForm = () => {
        if (!email.trim() || !password.trim()) return 'All fields are required.';
        if (!email.includes('@')) return 'Invalid email format.';
        if (password.length < 8) return 'Password must be at least 8 characters long.';
        return '';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
    
        const validationError = validateForm();
        if (validationError) {
            setMessage(validationError);
            setLoading(false);
            return;
        }
    
        try {
            const response = await axios.post('https://agpipefitting.org.et/api/admin-login', {
                email,
                password
            });
    
            if (response.status === 200 && response.data.token) {
                // Store the token and admin data
                localStorage.setItem('isAdminLoggedIn', 'true');
                localStorage.setItem('adminToken', response.data.token);  // Save token
                localStorage.setItem('admin', JSON.stringify(response.data.admin));  // Save admin data
                localStorage.setItem('role', response.data.admin.role);  // Save role

                setMessage('Login successful! Redirecting...');
                setRedirecting(true);
    
                // Redirect based on role
                const userRole = response.data.admin.role;
                if (userRole === 'admin') {
                    window.location.href = '/admin-dashboard';
                } else if (userRole === 'manager') {
                    window.location.href = '/manager-dashboard';
                } else if (userRole === 'expert') {
                    window.location.href = '/expert-dashboard';
                } else if (userRole === 'plan') {
                    window.location.href = '/production_Stock_dashboard';
                }
            } else {
                setMessage(response.data.message || 'Invalid credentials.');
            }
        } catch (error) {
            setMessage(error.response?.data?.message || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show && !redirecting} onHide={handleClose} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title className="w-100 text-center h4">Admin Portal</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="form-label">Email Address</label>
                        <div className="input-group">
                            <span className="input-group-text">
                                <FaEnvelope />
                            </span>
                            <input
                                type="email"
                                className="form-control"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@example.com"
                                required
                            />
                        </div>
                    </div>

                    <div className="mb-4">
                        <label className="form-label">Password</label>
                        <div className="input-group">
                            <span className="input-group-text">
                                <FaLock />
                            </span>
                            <input
                                type="password"
                                className="form-control"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                        </div>
                    </div>

                    {message && (
                        <div className={`alert ${message.includes('successful') ? 'alert-success' : 'alert-danger'}`}>
                            {message.includes('successful') ? <FaCheckCircle /> : <FaExclamationCircle />}
                            <span>{message}</span>
                        </div>
                    )}

                    <Button type="submit" variant="primary" className="w-100" disabled={loading}>
                        {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Sign In'}
                    </Button>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default AdminLoginModal;
